/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDto } from '../../models/contract-dto';

export interface ContractGetCurrent$Params {
}

export function contractGetCurrent(http: HttpClient, rootUrl: string, params?: ContractGetCurrent$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDto>> {
  const rb = new RequestBuilder(rootUrl, contractGetCurrent.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDto>;
    })
  );
}

contractGetCurrent.PATH = '/v1/Contract/GetCurrent';
